import React from 'react';
import { useSelector } from 'react-redux';
import { useHistory } from 'react-router-dom';
import Helmet from 'react-helmet';
import { CircularProgress } from '@material-ui/core';

import DirectDonorsToDonationPage from 'retired/DirectDonorsToDonationPage';
import { selectOrganization, selectUser } from 'entities/user/selectors';

import { Privileges } from '../../utils/privileges';

import RegisterWithPayPalBlock from './RegisterWithPayPalBlock';

const OrganizationPayPalIntroPage = () => {
  const organization = useSelector(selectOrganization);
  const user = useSelector(selectUser);

  const payPalPayerId = organization?.paypalPayerId;

  const history = useHistory();

  if (!user) {
    return (
      <>
        <Helmet title="Register with PayPal" />
        <h1>Register with PayPal</h1>
        <CircularProgress />
      </>
    );
  }

  if (payPalPayerId) {
    history.replace('/donations');
  }

  const setupAllowed = user.hasPrivilege(Privileges.DONATION_MANAGE_RULES);

  return (
    <>
      <Helmet title="Register with PayPal" />
      <h1>Register with PayPal</h1>
      <>
        {organization && (
          <>
            {setupAllowed ? (
              <RegisterWithPayPalBlock organization={organization}>
                <li>
                  <DirectDonorsToDonationPage organization={organization}>
                    Once your details are confirmed by PayPal, you can direct donors to your
                    nonprofit donation page by following this link:{' '}
                  </DirectDonorsToDonationPage>
                </li>
              </RegisterWithPayPalBlock>
            ) : (
              <div>Uh oh! Looks like you don&apos;t have permission to set up donations.</div>
            )}
          </>
        )}
      </>
    </>
  );
};

export default OrganizationPayPalIntroPage;
